<template>
    <div>
        <h2 class="sub_title">チャット以外のお問い合わせ</h2>
        <div class="mailLink">
            <div class="btnBox">
                <div>
                    <a :href="setContactUrl()">
                        <button class="btn btn-primary btn-lg btn-inquiry">
                            メールで問い合わせする
                        </button>
                    </a>
                </div>
                <div id="toggleButton">
                    <button
                        class="btn btn-primary btn-lg btn-inquiry"
                        @click="toggle('1000')"
                    >
                        お電話で問い合わせする
                    </button>
                </div>
            </div>
        </div>
        <div id="toggleBox" v-show="showTelInquiry.indexOf('1000') >= 0">
            <div class="card bg-light mb-3">
                <div class="card-header">
                    <p>
                        <span class="strong cardTitle">お電話でのお問い合わせ</span>
                    </p>
                </div>
                <div class="card-body">
                    <p>
                        <span class="strong phoneNumber">ローソンカスタマーセンター</span>
                    </p>
                    <p>
                        <span class="strong phoneNumber">0120-07-3963</span>
                    </p>
                    <p>
            <span class="strong caution">
              月曜～金曜（祝祭日除く）9:00-17:00
            </span>
                    </p>
                </div>
            </div>
            <NoticeBox :notice="notice" />
            <div class="VG-group">
                <p class="VG-sentence">
                    <span class="VG-title strong"> 音声ガイダンス案内の選択肢 </span>
                </p>
                <p class="VG-sentence">
          <span class="VG-subSentence">
            ガイダンスに従い、番号（
            <img class="guide-num" src="img/num_1.png" alt="1"/>
            ～
            <img class="guide-num" src="img/num_6.png" alt="6"/>
            ）をプッシュし、ご用件をお選びください。
          </span>
                </p>
                <p class="VG-sentence">
          <span class="VG-subSentence">
            お選びいただいたご用件に応じて、オペレーターか自動音声が応答します。
          </span>
                </p>
                <p>
                    <img
                        class="VG-img"
                        src="img/VoiceGuidanceTable.png"
                        alt="音声ガイダンス案内の選択肢"
                    />
                </p>
                <p class="VG-sentence">
          <span class="css-br">
            ※冒頭のアナウンス終了後、メニューを案内するガイダンスが流れ始めましたら、<br/>
          </span>
                    <span class="VG-subSentence mb-displaynone"></span>
                    <span>該当の番号を押してください。</span>
                </p>
                <p class="VG-sentence">
          <span class="VG-subSentence">
            目的のメニューへ遷移させることができ、アナウンスを短縮することが可能です。
          </span>
                </p>
                <p class="VG-sentence">
                    <span> ※内容は予告なく変更される場合があります。</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import NoticeBox from "@/components/NoticeBox.vue";
export default {
    name: "InquiryNavi",
    components: {
        NoticeBox,
    },
    data() {
        return {
            showTelInquiry: [],
        };
    },
    props: [
        'notice',
    ],
    methods: {
        setContactUrl: function () {
            return process.env.VUE_APP_INFO_URL + '/lawson/input_privacy.html'
        },
        toggle: function (data) {
            if (this.showTelInquiry.indexOf(data) >= 0) {
                this.showTelInquiry = this.showTelInquiry.filter((n) => n !== data);
            } else {
                this.showTelInquiry.push(data);
            }
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
    color: #42b983;
}

.button-group {
    padding: 10px;
}

.mailLink {
    margin: 1.2em;
}

.btn-inquiry {
    min-width: 270px;
}

.cardTitle {
    font-size: 1.4em;
}

.card {
    margin-top: 1em;
}

.VG-group {
    width: 100%;
    max-width: 650px;
    margin: 1rem auto;
}

.VG-sentence {
    text-align: left;
    position: relative;
}

.VG-subSentence {
    margin-left: 1rem;
}

.guide-num {
    width: 20px;
    height: auto;
    vertical-align: top;
}

.VG-img {
    width: 100%;
    max-width: 100%;
    height: auto;
}

.VG-title {
    margin-left: 1.5em;
}

.VG-title::before {
    background: #000;
    content: "";
    height: 13px; /*四角のサイズ*/
    width: 13px; /*四角のサイズ*/
    left: 0;
    position: absolute;
    top: 3px;
}
.cardTitle {
    font-size: 1.4em;
}
.card {
    margin-top: 1em;
}
.bg-warn {
    background-color: #ffffcc;
}
@media screen and (max-width: 600px) {
    .css-br br {
        display: none;
    }

    .mb-displaynone {
        display: none;
    }

    .VG-title::before {
        background: #000;
        content: "";
        height: 10px; /*四角のサイズ*/
        width: 10px; /*四角のサイズ*/
        left: 0;
        position: absolute;
        top: 3px;
    }

    .VG-sentence {
        text-align: left;
        position: relative;
        font-size: 0.8em;
    }

    .VG-subSentence {
        margin-left: 0.5rem;
    }

    .VG-subSentence br {
        display: none;
    }

    .guide-num {
        width: 15px;
        height: auto;
        vertical-align: top;
    }
}
</style>
